import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/meritve/drob/telesnaOcena";

export const fetchBodyConformationAssessmentPage = createAsyncThunk(
  "body-conformation-assessment/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * POST /api/dog/meritve/drob/telesnaOcena
 */
export const createBodyConformationAssessment = createAsyncThunk(
  "body-conformation-assessment/create",
  async (bodyConformationAssessmentData, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(
        baseUrl,
        bodyConformationAssessmentData
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * PUT /api/dog/meritve/drob/telesnaOcena/{id}
 */
export const updateBodyConformationAssessment = createAsyncThunk(
  "body-conformation-assessment/update",
  async ({ id, bodyConformationAssessmentData }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(
        `${baseUrl}/${id}`,
        bodyConformationAssessmentData
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * GET /api/dog/meritve/drob/telesnaOcena/{id}
 */
export const fetchBodyConformationAssessmentById = createAsyncThunk(
  "body-conformation-assessment/fetch-by-id",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const bodyConformationAssessmentSlice = createSlice({
  name: "bodyConformationAssessment",
  initialState: {
    details: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {
    resetBodyConformationAssessment(state) {
      state.details = null;
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    /* Get List */
    builder
      .addCase(
        fetchBodyConformationAssessmentPage.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.page = action.payload;
        }
      )
      .addCase(
        fetchBodyConformationAssessmentPage.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      )
      .addCase(
        fetchBodyConformationAssessmentPage.pending,
        (state, _action) => {
          state.isLoading = true;
          state.error = null;
        }
      );
    /* Create assessment */
    builder
      .addCase(createBodyConformationAssessment.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createBodyConformationAssessment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(createBodyConformationAssessment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    /* Update assessment */
    builder
      .addCase(updateBodyConformationAssessment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(updateBodyConformationAssessment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateBodyConformationAssessment.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });
    /* Fetch by id */
    builder
      .addCase(fetchBodyConformationAssessmentById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchBodyConformationAssessmentById.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.details = action.payload;
        }
      )
      .addCase(
        fetchBodyConformationAssessmentById.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      );
  },
});

export const { resetBodyConformationAssessment } =
  bodyConformationAssessmentSlice.actions;
export default bodyConformationAssessmentSlice.reducer;
